"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroSection = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var HeroSection = /** @class */ (function (_super) {
    __extends(HeroSection, _super);
    function HeroSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderSVG = function () {
            if (_this.props.design === "box") {
                return (react_1.default.createElement("svg", { className: "absolute inset-0 -z-10 h-full w-full [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]", style: { stroke: "#e5e7eb" }, "aria-hidden": "true" },
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("pattern", { id: "83fd4e5a-9d52-42fc-97b6-718e5d7ee527", width: 200, height: 200, x: "50%", y: -1, patternUnits: "userSpaceOnUse" },
                            react_1.default.createElement("path", { d: "M100 200V.5M.5 .5H200", fill: "none" }))),
                    react_1.default.createElement("svg", { x: "50%", y: -1, className: "overflow-visible", style: {
                            fill: "#f9fafb",
                        } },
                        react_1.default.createElement("path", { d: "M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z", strokeWidth: 0 })),
                    react_1.default.createElement("rect", { width: "100%", height: "100%", strokeWidth: 0, fill: "url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)" })));
            }
            return null;
        };
        _this.renderDesign = function () {
            if (_this.props.design === "split") {
                return (react_1.default.createElement("div", { className: "relative h-64 mt-14 w-full sm:h-72 md:h-96 lg:mt-0 lg:absolute lg:inset-y-0 lg:right-0 lg:h-full lg:w-1/2" },
                    react_1.default.createElement("img", { className: "absolute inset-0 h-full w-full object-cover", src: _this.props.image, alt: "" })));
            }
            else if (_this.props.design === "angled") {
                return (react_1.default.createElement("div", { className: "bg-gray-50 mt-14 lg:absolute lg:inset-y-0 lg:mt-0 lg:right-0 lg:w-1/2 relative" },
                    react_1.default.createElement("svg", { className: "absolute inset-y-0 left-0 hidden h-full w-44 transform fill-white lg:block", viewBox: "0 0 100 100", preserveAspectRatio: "none", "aria-hidden": "true" },
                        react_1.default.createElement("polygon", { points: "0,0 90,0 50,100 0,100" })),
                    react_1.default.createElement("img", { className: "aspect-[3/2] object-cover lg:aspect-auto lg:h-full lg:w-full", src: _this.props.image, alt: "" })));
            }
            else if (_this.props.design === "box") {
                return (react_1.default.createElement("div", { className: "relative h-64 mt-14 w-full sm:h-72 md:h-96 lg:mt-0 lg:absolute lg:inset-y-0 lg:right-0 lg:h-full lg:w-1/2" },
                    react_1.default.createElement("svg", { viewBox: "0 0 366 729", role: "img", className: "mx-auto w-[22.875rem] max-w-full drop-shadow-xl" },
                        react_1.default.createElement("defs", null,
                            react_1.default.createElement("clipPath", { id: "2ade4387-9c63-4fc4-b754-10e687a0d332" },
                                react_1.default.createElement("rect", { width: 316, height: 684, rx: 36 })))),
                    react_1.default.createElement("div", { className: "absolute w-full left-0 top-0 lg:top-40" },
                        react_1.default.createElement("img", { className: "w-full rounded-md lg:h-full lg:w-auto object-cover", src: _this.props.image, alt: "" }))));
            }
            else {
                return (react_1.default.createElement("div", { className: "sm:mx-auto sm:max-w-3xl sm:px-6" },
                    react_1.default.createElement("div", { className: "py-12 sm:relative sm:mt-12 sm:py-16 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2" },
                        react_1.default.createElement("div", { className: "hidden sm:block" },
                            react_1.default.createElement("div", { className: "absolute inset-y-0 left-1/2 w-screen bg-gray-50 rounded-l-3xl lg:left-80 lg:right-0 lg:w-full" }),
                            react_1.default.createElement("svg", { className: "absolute top-8 right-1/2 -mr-3 lg:m-0 lg:left-0", width: "404", height: "392", fill: "none", viewBox: "0 0 404 392" },
                                react_1.default.createElement("defs", null,
                                    react_1.default.createElement("pattern", { id: "837c3e70-6c3a-44e6-8854-cc48c737b659", x: "0", y: "0", width: "20", height: "20", patternUnits: "userSpaceOnUse" },
                                        react_1.default.createElement("rect", { x: "0", y: "0", width: "4", height: "4", className: "text-gray-200", fill: "currentColor" }))),
                                react_1.default.createElement("rect", { width: "404", height: "392", fill: "url(#837c3e70-6c3a-44e6-8854-cc48c737b659)" }))),
                        react_1.default.createElement("div", { className: "relative -mr-40 sm:mx-auto sm:max-w-3xl lg:max-w-none lg:h-full lg:pl-12" },
                            react_1.default.createElement("img", { className: "w-full rounded-md lg:h-full lg:w-auto object-cover", src: _this.props.image, alt: "" })))));
            }
        };
        return _this;
    }
    HeroSection.prototype.render = function () {
        var contentClassName = "";
        var titleClassName = "";
        if (this.props.size === "small") {
            contentClassName =
                "mt-4 text-base leading-7 text-gray-500 whitespace-pre-line break-words";
            titleClassName =
                "text-3xl text-gray-900 font-extrabold tracking-tight sm:text-4xl";
        }
        else {
            contentClassName =
                "mt-6 text-xl text-gray-500 text-justify whitespace-pre-line break-words";
            titleClassName =
                "text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl";
        }
        var defaultClassName = "overflow-hidden lg:relative lg:py-48";
        if (this.props.className) {
            defaultClassName += " ".concat(this.props.className);
        }
        return (react_1.default.createElement("div", { className: defaultClassName },
            this.renderSVG(),
            react_1.default.createElement("div", { className: "mx-auto max-w-md sm:max-w-3xl lg:max-w-7xl lg:grid lg:grid-cols-2 lg:gap-24" },
                react_1.default.createElement("div", { className: "mt-6 lg:mt-0 sm:max-w-xl" },
                    react_1.default.createElement("h1", { className: titleClassName }, this.props.title),
                    react_1.default.createElement("p", { className: contentClassName }, this.props.content),
                    this.props.callToAction && (react_1.default.createElement("div", { className: "mt-4 sm:max-w-lg sm:w-full sm:flex" }, this.props.callToAction)))),
            this.renderDesign()));
    };
    return HeroSection;
}(react_1.Component));
exports.HeroSection = HeroSection;
//# sourceMappingURL=index.js.map